import React from 'react';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { post } from '../../services/request';
import { observer, inject } from 'mobx-react';
import { observable } from 'mobx';
import './style.css';

@inject('user', 'app')
@observer
class OfferPreview extends React.Component {
  @observable url = '';

  componentWillUnmount() {
    this.props.closePanel();
  }

  async componentDidMount() {
    const { data, user, url } = this.props;
    if (url) return;
    const res = await post(`/api/v1/sign`, data, user.accessToken);
    this.url = res.url;
  }

  render() {
    const { closePanel, url } = this.props;
    const pageUrl = this.url || url;
    return (
      <Modal
        isOpen={true}
        onDismiss={closePanel}
        isBlocking={false}
        containerClassName="sale--preview--modal"
      >
        {pageUrl ? (
          <iframe src={pageUrl} title="preview">
            <a href={pageUrl} target="_blank">
              Öffnen
            </a>
          </iframe>
        ) : null}
      </Modal>
    );
  }
}

export default OfferPreview;



// WEBPACK FOOTER //
// ./src/app/components/OfferPreview/index.jsx